'use strict';

import React from 'react';

require('styles//DpsDataTable.css');

class DpsDataTableComponent extends React.Component {
  loadJSON(callback,jsonfile){
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType('application/json');
    xobj.open('GET', jsonfile, true);
    xobj.onreadystatechange = function()
    {
      if(xobj.readyState == 4 && xobj.status == '200')
      {
        callback(xobj.responseText);
      }
    };
    xobj.send(null);
  }
  getDataColumns(item,year,i){
    if(item!=null){
        var row=this.findOfProp(year,item.rows,'year');
        if(row!=null){
          return <td key={i}>{row.value}</td>
        }
    }
    return <td></td>
  }
  findOfProp(value, arr, prop) {
    for(var i = 0; i < arr.length; i++) {
        if(arr[i][prop] == value) {
            return arr[i];
        }
    }
    return null;
  }
  render() {
    return (
      <div className="dpsdatatable-component">
         <table className="dataTable"><tbody><tr><td>Область</td>{this.props.years.map((year,i1)=><td key={i1}>{year}</td>)}</tr>
         {this.props.dataTable.map((d,i2)=><tr key={i2}><td>{d.nameobl}</td>
         {this.props.years.map((year,i3)=>this.getDataColumns(d,year,i3))}</tr>)}
         </tbody></table>
      </div>
    );
  }
}

DpsDataTableComponent.displayName = 'DpsDataTableComponent';

// Uncomment properties you need
// DpsDataTableComponent.propTypes = {};
// DpsDataTableComponent.defaultProps = {};

export default DpsDataTableComponent;



// WEBPACK FOOTER //
// ./src/components/DpsDataTableComponent.js